import { render, staticRenderFns } from "./PrintClassEvaluationButton.vue?vue&type=template&id=52ac6a50&scoped=true"
import script from "./PrintClassEvaluationButton.vue?vue&type=script&lang=ts"
export * from "./PrintClassEvaluationButton.vue?vue&type=script&lang=ts"
import style0 from "./PrintClassEvaluationButton.vue?vue&type=style&index=0&id=52ac6a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac6a50",
  null
  
)

export default component.exports